import React from 'react';

type BottomBarProps = {
  onExport: () => void;
  onShareCreation: () => void;
  isReadOnly: boolean;
  isExporting: boolean;
};

export default function BottomBar({ onExport, onShareCreation, isReadOnly, isExporting }: BottomBarProps) {
  return (
    <div className="bottom-bar">
      <div className="bottom-left">
        {!isReadOnly && (
          <button className="bottom-btn" type="button" onClick={onShareCreation}>
            <img src="/assets/icon/icons8-export-50.png" alt="" aria-hidden="true" />
            Sauvegarder / Partager la création
          </button>
        )}
      </div>
      <div className="bottom-right">
        <button className="bottom-cta" type="button" onClick={onExport} disabled={isExporting} data-tutorial="finish-btn">
          Terminer la configuration
        </button>
      </div>
      <div className="bottom-mobile">
        {!isReadOnly && (
          <button className="bottom-mobile-btn" type="button" onClick={onShareCreation}>
            Sauvegarder / Partager la création
          </button>
        )}
        <button className="bottom-mobile-cta" type="button" onClick={onExport} disabled={isExporting}>
          Terminer la configuration
        </button>
      </div>
    </div>
  );
}
